import { ClipboardCheck, Settings as Cog, Mail, MessageCircle, MessageSquare, MessagesSquare, Phone } from 'lucide-react'
import { CHANNEL_NAMES } from '../lib/labels'

const ICONS = { email: Mail, sms: MessageSquare, chat: MessageCircle, voice: Phone, whatsapp: MessagesSquare, task: ClipboardCheck, system: Cog } as const

/** Square channel badge: email blue, SMS green, chat violet, voice rose. */
export function ChannelBadge({ channel, size = 22 }: { channel: string | null | undefined; size?: number }) {
  const c = (channel && channel in ICONS ? channel : 'system') as keyof typeof ICONS
  const Icon = ICONS[c]
  return (
    <span className={`ch ch-${c}`} style={{ width: size, height: size }} title={CHANNEL_NAMES[c] ?? c}>
      <Icon strokeWidth={2} style={{ width: Math.round(size * 0.6), height: Math.round(size * 0.6) }} />
    </span>
  )
}

export function channelName(c: string | null | undefined) { return c ? CHANNEL_NAMES[c] ?? c : '' }
